var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickgrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9.454 7.092",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#999;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-9.544 -7.154)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M39.279,14.17a.591.591,0,0,0-.836,0l-5.491,5.491-1.945-1.945a.591.591,0,1,0-.836.836l2.363,2.363a.591.591,0,0,0,.836,0l5.909-5.909a.591.591,0,0,0,0-.836Z",
    transform: "translate(-20.454 -6.843)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickgrey);
export default __webpack_public_path__ + "static/media/tickgrey.c07f449a15425a92d0ad0285033a0c11.svg";
export { ForwardRef as ReactComponent };